import { combineReducers } from 'redux';
import user from './user';
import counterpartySearchResult from './counterpartySearch';
import advancedSearch from './advancedSearch';
import selectionOfSuppliers from './selectionOfSuppliers';
import etpRegistration from './etpRegistration';
import purchasingHistory from './purchasingHistory';
import sidebar from './sidebar';

const rootReducer = combineReducers({
  user,
  counterpartySearchResult,
  advancedSearch,
  selectionOfSuppliers,
  etpRegistration,
  purchasingHistory,
  sidebar,
});

export default rootReducer;
